var SCM = SCM || {};

SCM.DynamicDiscovery = (function (SCM) {
    const tooltips = document.getElementsByClassName('js-navbar-ai-assistant-tooltip');

    return {
        init: init
    };

    function init() {
        listenForSignInDialog();

        if (!localStorage.getItem("dynamicDiscoveryFirstTimeSession")) {
            toggleFirstTimeSession();
        }
    }

    function toggleFirstTimeSession() {
        if (!tooltips.length)
            return;

        localStorage.setItem("dynamicDiscoveryFirstTimeSession", '1');

        for (tooltip of tooltips) {
            tooltip.classList.remove('hidden');
            tooltip.addEventListener('click', (e) => { e.stopPropagation() })
        }

        document.addEventListener('click', hideTooltipThenRemoveListener);
    }

    function hideTooltipThenRemoveListener() {
        for (tooltip of tooltips) {
            tooltip.classList.add('hidden');
        }

        document.removeEventListener('click', hideTooltipThenRemoveListener);
    }

    function listenForSignInDialog() {
        let assistantLinks = document.getElementsByClassName('js-navbar-ai-assistant-link');

        for (assistantLink of assistantLinks) {
            assistantLink.addEventListener('click', openSignInDialog);
        }
    }

    function openSignInDialog() {
        let assistantLinks = document.getElementsByClassName('js-navbar-ai-assistant-link');

        for (assistantLink of assistantLinks) {
            assistantLink.removeEventListener('click', openSignInDialog);
        }

        let subdomain = App.CurrentSubdomain;
        let ajaxUrl = subdomain === '' ? '/DynamicDiscovery/DynamicDiscoverySignIn' : `/${subdomain}/DynamicDiscovery/DynamicDiscoverySignIn`;
        let modalErrorMessage = 'An error occurred while trying to open the sign in dialog.';

        SCM.Ajax.get(ajaxUrl, null)
            .expectHtml()
            .then(function (result) {
                SCM.Modals.showModal(result);
            })
            .catch(function (reason) {
                console.error(reason);
                SCM.Modals.showModal(modalErrorMessage);
            });

        listenForDialogClose();
    }

    function listenForDialogClose() {
        $body.on('click', '.js-close-modal', _removeModalBg);
        $body.on('click', '.js-modal-overlay', _removeModalBg);
    }

    // The actual modal close is handled by SCM.Modals.js but the background stays up
    function _removeModalBg() {
        $body.off('click', '.js-close-modal', _removeModalBg);
        $body.off('click', '.js-modal-overlay', _removeModalBg);

        let modalBgs = document.getElementsByClassName('reveal-modal-bg');

        for (modalBg of modalBgs) {
            modalBg.remove();
        }

        listenForSignInDialog();
    }
})(SCM);
